"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _DragBox = _interopRequireDefault(require("./DragBox.js"));

var _easing = require("../easing.js");

var _condition = require("../events/condition.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/DragZoom
 */


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */

/**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */
var DragZoom =
/** @class */
function (_super) {
  __extends(DragZoom, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function DragZoom(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    var condition = options.condition ? options.condition : _condition.shiftKeyOnly;
    _this = _super.call(this, {
      condition: condition,
      className: options.className || 'ol-dragzoom',
      minArea: options.minArea
    }) || this;
    /**
     * @private
     * @type {number}
     */

    _this.duration_ = options.duration !== undefined ? options.duration : 200;
    /**
     * @private
     * @type {boolean}
     */

    _this.out_ = options.out !== undefined ? options.out : false;
    return _this;
  }
  /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */


  DragZoom.prototype.onBoxEnd = function (event) {
    var map = this.getMap();
    var view =
    /** @type {!import("../View.js").default} */
    map.getView();
    var geometry = this.getGeometry();

    if (this.out_) {
      var rotatedExtent = view.rotatedExtentForGeometry(geometry);
      var resolution = view.getResolutionForExtentInternal(rotatedExtent);
      var factor = view.getResolution() / resolution;
      geometry = geometry.clone();
      geometry.scale(factor * factor);
    }

    view.fitInternal(geometry, {
      duration: this.duration_,
      easing: _easing.easeOut
    });
  };

  return DragZoom;
}(_DragBox["default"]);

var _default = DragZoom;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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